import * as _ from "lodash";
import {DashboardWidget} from "../models/DashboardWidget";

interface WidgetParams {
    CHART_TIMESTAMPS?: string;
    CHART_DATA_ZOOM?: string;
    CHART_IS_TALL?: string;
    CHART_TYPE?: string;
    CHART_CONNECT_TO_TILES?: string;
    CHART_THRESHOLDS?: string;
    CHART_TITLE?: string;
    CHART_AGGREGATION_PERIOD?: string;
    CHART_AGGREGATION_TYPE?: string;
    CHART_SIZE?: string;
    CHART_LABELS?: string;
    CHART_DATA_RANGE?: string;
    CHART_HIDE_SINGLE_GAPS?: string;
    CHART_CONVERT_ALL_DATA? :string;
    IFRAME_URL?: string;
}

interface WidgetConfig {
    dashboard_category_id?: number;
    dashboard_id?: number;
    dashboard_widget_type_id?: number;
    id?: string,
    order?: number;
    type?: string;
    params?: WidgetParams;
}

var defaultChartWidgetConfig: WidgetConfig = {
    dashboard_category_id: 0,
    dashboard_id: 0,
    dashboard_widget_type_id: 3,
    id: null,
    order: 1,
    type: 'chart',
    params: {
        CHART_TIMESTAMPS: '2',
        CHART_DATA_ZOOM: '3',
        CHART_IS_TALL: '0',
        CHART_TYPE: '1',
        CHART_CONNECT_TO_TILES: '2',
        CHART_THRESHOLDS: '1',
        CHART_TITLE: '',
        CHART_AGGREGATION_PERIOD: '0',
        CHART_AGGREGATION_TYPE: '0',
        CHART_SIZE: '2',
        CHART_LABELS: '1',
        CHART_DATA_RANGE: '2',
    }
};

var defaultChannelsWidgetConfig: WidgetConfig = {
    dashboard_category_id: 0,
    dashboard_id: 0,
    dashboard_widget_type_id: 1,
    id: null,
    order: 1,
    type: 'channels',
};

var defaultIframeWidgetConfig: WidgetConfig = {
    dashboard_category_id: 0,
    dashboard_id: 0,
    dashboard_widget_type_id: 21,
    id: null,
    order: 1,
    type: 'iframe',
    params: {
        IFRAME_URL: '',
        CHART_SIZE: '6'
    }
};

export class WidgetTool {

    static extendWidgetConfig(config1: WidgetConfig, config2: WidgetConfig){
        var params = _.extend({}, config1['params'], config2['params']);
        var res = _.extend({}, config1, config2);
        res['params'] = params;
        return res;
    }

    static createWidget(type, config: WidgetConfig){
        if(type === 'chart') {
            config = this.extendWidgetConfig(defaultChartWidgetConfig, config);
        } else if (type === 'channels'){
            config = _.extend({}, defaultChannelsWidgetConfig, config);
        } else if (type === 'iframe'){
            config = this.extendWidgetConfig(defaultIframeWidgetConfig, config);
        }
		if(!config['id']) config['id'] = _.uniqueId();

		config['params'] = <any> _.map(<any> config['params'], (value, key) => {
		    return {'key': key, 'value': value}
		});
		return new DashboardWidget(config)
	}

     static getChannels(widgetId, channels: Backbone.Model[]) {
        return _.map(channels, (channel, i) => {
            return _.extend({
                dashboard_category_id: 0,
                dashboard_channel_dashboard_id: 0,
                dashboard_channel_id: Number(String(widgetId) + String(channel.get('channel_id'))),
                dashboard_channel_name: channel.get('channel_name'),
                dashboard_channel_order: i,
                dashboard_channel_secondary_order: i,
                dashboard_widget_id: widgetId
            }, channel.attributes)
        });
    }

}


// WEBPACK FOOTER //
// ./srv/public/js/common/widgetTool.ts